import { useHistory } from "react-router-dom";
import * as Styles from "./Benefits.styes";

import Check from "assets/images/health-analyse/check.svg";
import Cross from "assets/images/health-analyse/cross.svg";
import * as CoachActions from "redux/coach/coach.actions";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getS3ImageUrl, IS_LOCAL } from "configs/utils";
import MainHeader from "../../../components/Wrapper/HealthAnalyseHeader";
import { OPTION } from "routes/routes";
import BenefitSlider from "./BenefitSlider";
import Placeholder from "assets/images/placeholder.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { useRef } from "react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import DataSlider from "components/common/DataSlider";

function Benefits() {
  const dispatch = useDispatch();
  const coachFeedback = useSelector((state) => state.coach.feedback);
  const swiperRef = useRef(null);
  console.log("🚀 ~ Benefits ~ coachFeedback:", coachFeedback);

  const history = useHistory();

  useEffect(() => {
    const coach_website_url = IS_LOCAL
      ? "https://ronja-fci49818.foodiary.app"
      : `${window.location.protocol}//${window.location.host}`;

    dispatch(
      CoachActions.trainerIdRequest({
        formData: { coach_website_url },
        callback: (res) => {
          dispatch(
            CoachActions.coachDataRequest({
              formData: { trainerID: res?.trainerID },
              callback: () => null,
            })
          );
        },
      })
    );
  }, [dispatch]);

  const handleBtnClick = () => {
    history.push(OPTION);
  };

  const features = [
    {
      id: 1,
      description: "100% Kostenrückerstattung",
      pro: true,
      plus: true,
    },
    {
      id: 2,
      description: "Persönlicher Ernährungsplan",
      pro: true,
      plus: true,
    },
    {
      id: 3,
      description: "Eigene App mit 1700 Rezepten",
      pro: true,
      plus: true,
    },
    {
      id: 4,
      description: "Digitale Lernacademy",
      pro: true,
      plus: true,
    },
    {
      id: 5,
      description: "8 Wochen Onlinekurs",
      pro: true,
      plus: true,
    },
    {
      id: 6,
      description: "Handouts, Wissensquiz",
      pro: true,
      plus: true,
    },
    {
      id: 7,
      description: "Einzelgespräche",
      pro: false,
      plus: true,
    },
    {
      id: 8,
      description: "Fortschrittsanalyse",
      pro: false,
      plus: true,
    },
    {
      id: 9,
      description: "WhatsApp Support",
      pro: false,
      plus: true,
    },
    {
      id: 10,
      description: "Persönlicher Ernährungscoach",
      pro: false,
      plus: true,
    },
  ];

  return (
    <Styles.Container>
      <div className="main-div">
        <MainHeader
          headline={"Auswertung"}
          subHeadline={"Wir erreichen gemeinsam dein Ziel!"}
          handleNextPage={handleBtnClick}
          noBackButton={true}
        />
        <Styles.ContentSection>
          <Styles.ComparisonTable>
            <Styles.TableHeader>
              <div className="column-title empty-cell"></div>
              <div className="column-title">PLUS</div>
              <div className="column-title">PRO</div>
            </Styles.TableHeader>

            {features.map((feature) => (
              <Styles.TableRow key={feature.id}>
                <Styles.FeatureCell>{feature.description}</Styles.FeatureCell>
                <Styles.StatusCell>
                  <img
                    src={feature.pro ? Check : Cross}
                    alt={feature.pro ? "Included" : "Not included"}
                  />
                </Styles.StatusCell>
                <Styles.StatusCell>
                  <img
                    src={feature.plus ? Check : Cross}
                    alt={feature.plus ? "Included" : "Not included"}
                  />
                </Styles.StatusCell>
              </Styles.TableRow>
            ))}
          </Styles.ComparisonTable>
          <Styles.Divider />
        </Styles.ContentSection>

        {/* Mobile Testimonial Slider */}
        <Styles.MobileSliderView>
          <BenefitSlider testimonials={coachFeedback} />
        </Styles.MobileSliderView>

        {/* Desktop Testimonial Slider */}
        <Styles.DesktopGridView>
          <Styles.Title>Das sagen unsere Klienten:</Styles.Title>
          <div className="desktop-slider-container">
            <DataSlider
              slides={coachFeedback}
              slidesPerView={3}
              border={0}
              styleProps={{
                slideBox: {
                  border: "none",
                  boxShadow: "none",
                },
              }}
              renderSlideContent={(testimonial) => (
                <Styles.TestimonialCard>
                  <Styles.TestimonialHeader>
                    <Styles.ProfileImageWrapper>
                      <img
                        src={
                          testimonial?.picture
                            ? getS3ImageUrl(testimonial?.picture)
                            : Placeholder
                        }
                        alt={testimonial.name}
                      />
                    </Styles.ProfileImageWrapper>
                    <Styles.TestimonialUser>
                      <Styles.Stars>
                        {"★".repeat(testimonial.rating)}
                      </Styles.Stars>
                      <Styles.UserName>
                        {testimonial.prename} {testimonial.lastname}
                      </Styles.UserName>
                      {/* <Styles.UserAge>{testimonial.age}</Styles.UserAge> */}
                    </Styles.TestimonialUser>
                  </Styles.TestimonialHeader>
                  <Styles.TestimonialText>
                    {testimonial.text.slice(0, 200) + "..."}
                  </Styles.TestimonialText>
                </Styles.TestimonialCard>
              )}
            />
          </div>
        </Styles.DesktopGridView>
      </div>
      <button
        onClick={handleBtnClick}
        className="btn-dark w-full mt-8 btn-show"
      >
        Weiter
      </button>
    </Styles.Container>
  );
}

export default Benefits;
